import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "isChatOpen", "isMenuOpen", "enableQueriesParams", "onChatWidgetClick", "onChatOpen", "className", "messengers", "closeWidget", "zoneType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import { DIMENSION_TYPE, useBreakpoints } from '@carnica/utils/hooks';
import { cnBem, useChangeZIndex } from "../../../shared/lib";
import { OpenChat } from "../../../features/open-chat/ui";
import { selectChatCofig, selectIsChatOpen, selectIsMenuOpen, setChatOpen, setMenuOpen } from "../../../entities/settings/model";
import { Popover } from "../../../shared/ui";
import { MenuList } from "../../../widgets/navigation/ui";
import { addStoreImageUrlGroup } from "../../../entities/content/model";
import { setStoreImgPreview } from "../../../entities/message/model";
import { useAnalytics } from "../../../shared/analytics";
import { useChatOpenQuery } from "../../lib/hooks";
import styles from "./styles.pcss";
import { Chat } from "../Chat";
import { ChatWidgetContainer } from "./ChatWidgetContainer";
var cnChatWidget = cnBem('chat-widget', styles);
var ChatWidgetRender = /*#__PURE__*/forwardRef(function (props, ref) {
  var isOpen = props.isOpen,
    isChatOpen = props.isChatOpen,
    isMenuOpen = props.isMenuOpen,
    _props$enableQueriesP = props.enableQueriesParams,
    enableQueriesParams = _props$enableQueriesP === void 0 ? true : _props$enableQueriesP,
    onChatWidgetClick = props.onChatWidgetClick,
    onChatOpen = props.onChatOpen,
    className = props.className,
    _props$messengers = props.messengers,
    messengers = _props$messengers === void 0 ? [] : _props$messengers,
    closeWidget = props.closeWidget,
    zoneType = props.zoneType,
    otherProps = _objectWithoutProperties(props, _excluded);
  var buttonRef = useRef(null);
  var _useBreakpoints = useBreakpoints(),
    _useBreakpoints2 = _slicedToArray(_useBreakpoints, 1),
    breakpoint = _useBreakpoints2[0];
  var zIndexChat = useChangeZIndex();
  useAnalytics({
    isChatOpen: isChatOpen,
    isMenuOpen: isMenuOpen,
    messengers: messengers,
    zoneType: zoneType
  });
  useChatOpenQuery(enableQueriesParams);
  var open = isChatOpen || isMenuOpen;
  var isChatVisible = isChatOpen || messengers.length < 2;
  var view = useMemo(function () {
    if (breakpoint === DIMENSION_TYPE.TABLET) {
      return isMenuOpen ? 'block' : 'fullscreen';
    }
    return breakpoint === DIMENSION_TYPE.DESKTOP ? 'block' : 'fullscreen';
  }, [breakpoint, isMenuOpen]);
  return /*#__PURE__*/React.createElement("section", _extends({
    className: cnChatWidget('wrapper', [className, cnComponentsTheme('light')]),
    id: "chat-widget",
    onClick: onChatWidgetClick,
    ref: ref,
    style: {
      zIndex: zIndexChat
    }
  }, otherProps, {
    "data-t-id": "ui-ChatWidget"
  }), /*#__PURE__*/React.createElement(OpenChat, {
    className: cnChatWidget('button'),
    ref: buttonRef
  }), /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: cnChatWidget('overlay', {
      isOpen: open
    })
  }), /*#__PURE__*/React.createElement(Popover, {
    anchorRef: buttonRef,
    className: cnChatWidget('window', {
      view: view
    }),
    "data-portal-type": "widgetChat",
    direction: "leftStartDown",
    isOpen: open,
    offsetHorizontal: 8,
    onClickOutside: closeWidget,
    position: "fixed",
    style: _objectSpread(_defineProperty({}, '--chat-zindex', zIndexChat + 1), view === 'block' ? _defineProperty(_defineProperty({}, '--popover-top', 'auto'), '--popover-bottom', "".concat(buttonRef.current ? window.innerHeight - buttonRef.current.getBoundingClientRect().y - buttonRef.current.offsetHeight : 0, "px")) : {})
  }, /*#__PURE__*/React.createElement(ChatWidgetContainer, {
    isChatOpen: isChatOpen,
    isDesktop: breakpoint === DIMENSION_TYPE.DESKTOP,
    isMenuOpen: isMenuOpen,
    menuItemsCount: messengers.length,
    view: view,
    "data-t-id": "ui-ChatWidget"
  }, isChatVisible && /*#__PURE__*/React.createElement(Chat, {
    anchorRef: buttonRef,
    enableQueriesParams: enableQueriesParams,
    isOpen: isOpen,
    onChatOpen: onChatOpen
  }), isMenuOpen && /*#__PURE__*/React.createElement(MenuList, {
    messengers: messengers,
    title: "\u043E\u0442\u0432\u0435\u0442\u0438\u043C \u0432\u0435\u0437\u0434\u0435"
  }))));
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    isChatOpen: selectIsChatOpen(state),
    isMenuOpen: selectIsMenuOpen(state),
    messengers: selectChatCofig(state).messengers,
    zoneType: selectChatCofig(state).authZoneConfig.zoneType
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeWidget: function closeWidget() {
      dispatch(setChatOpen(false));
      dispatch(setMenuOpen(false));

      // Удаление данных. Превью фото.
      dispatch(setStoreImgPreview({
        isImgPreviewOpen: false,
        type: null
      }));
      dispatch(addStoreImageUrlGroup(null));
    }
  };
};
export var ChatWidget = connect(mapStateToProps, mapDispatchToProps)(ChatWidgetRender);